import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RefundConfirmationDialogModel } from './refund-confirmation-dialog.model';

@Component({
  standalone: false,
  selector: 'app-refund-confirmation-dialog',
  templateUrl: './refund-confirmation-dialog.component.html',
  styleUrls: ['./refund-confirmation-dialog.component.scss']
})
export class RefundConfirmationDialogComponent {
  model!: RefundConfirmationDialogModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RefundConfirmationDialogModel,
    public dialogRef: MatDialogRef<RefundConfirmationDialogComponent>) {
    this.model = data;
  }

  get closeButtonText() {
    if (!this.model.cancelButtonText) {
      return "No, Cancel"
    }
    return this.model.cancelButtonText;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onAction() {
    this.dialogRef.close(true);
  }
}
